<template>
  <slot name="header_close" />
  <div class="instruction-dialog">
    <div class="title">
      <span class="title_text">{{ $t("dialog.instruction.title") }}</span>
    </div>
    <div>
      <VueAgile ref="carouselRef" class="mb-3 pb-3" :centerMode="true">
        <div
          class="slider py-2"
          v-for="(text, index) in slideInstructions"
          :key="index"
        >
          <p class="slide_text mb-2">
            {{ $t(`${text}`) }}
          </p>
          <div class="my-auto">
            <img
              :src="
                require(`@/assets/images/instruction/instruction-${
                  index + 1
                }-${currentLanguage}.webp`).default
              "
              class="img"
              :class="{ active: isActive, 'text-danger': hasError }"
            />
          </div>
        </div>
        <!-- ACTIONS -->
        <template v-slot:prevButton>
          <i class="fas fa-chevron-left"></i>
        </template>
        <template v-slot:nextButton>
          <i class="fas fa-chevron-right"></i>
        </template>
      </VueAgile>
    </div>
  </div>
</template>

<script>
import { VueAgile } from "vue-agile";
import { useStore, mapGetters } from "vuex";

export default {
  components: {
    VueAgile,
  },

  data() {
    return {
      isActive: false,
      carouselRef: null,
      currentLanguage: "ru",
      hasError: false,
      slideInstructions: [
        "dialog.instruction.text1",
        "dialog.instruction.text2",
        "dialog.instruction.text3",
        "dialog.instruction.text4",
      ],
    };
  },
  computed: {
    ...mapGetters("auth", ["getLanguage"]),
  },
  updated() {
    if (this.isActive === false) {
      this.isActive = true;
    }
  },
  mounted() {
    this.currentLanguage = this.getLanguage;
  },
};
</script>

<style lang="scss">
.slider {
  height: 100%;
  display: block;
  // height: 500px;
}

.title_text {
  font-size: 22px;
  font-weight: 600;
}

.instruction-dialog {
  padding: 24px 28px;
  max-width: 810px;
  width: 100%;

  //   display: flex;
  //   align-items: center;
  //   gap: 24px;
  //   flex-direction: column;

  box-sizing: border-box;
  border-radius: 7px;
  background-color: white;

  //   text-align: center;

  //   display: flex;
  //   flex-direction: column;
  //   align-items: center;
  box-sizing: border-box;
  gap: 15px;
  border-radius: 10px;
  background: var(--block-color);
}

.slide_text {
  font-family: Gilroy;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  color: var(--text-second-color);
  padding-block: 20px;
  padding-left: 4px;
}

// .img {
//   width: 500px;
//   border-radius: 5px;
//   cursor: pointer;
//   margin: 0 auto;
// }

.img {
  max-width: calc(100% - 120px);
  margin: 0 auto;
}

.agile {
  //   max-width: 100%;
  //   height: 560px;

  &__nav-button {
    background: transparent;
    border: none;
    color: var(--text-second-color);
    cursor: pointer;
    font-size: 24px;
    height: 200px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition-duration: 0.3s;
    width: 40px;
    border-radius: 10px;

    &:hover {
      background-color: rgba(#000, 0.5);
      opacity: 1;
      color: white;
    }

    &--prev {
      left: 0;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }

    &--next {
      right: 0;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }

  //   &__slides {
  //     align-items: baseline;
  //   }

  &__dots {
    margin: 0 auto;
  }

  &__dot {
    margin: 0 10px;

    button {
      background-color: transparent;
      border: 1px solid var(--text-second-color);
      border-radius: 50%;
      cursor: pointer;
      display: block;
      height: 10px;
      font-size: 0;
      line-height: 0;
      margin: 0;
      padding: 0;
      transition-duration: 0.3s;
      width: 10px;
    }

    &--current,
    &:hover {
      button {
        background-color: var(--text-second-color);
      }
    }
  }
}

// @media screen and (max-width: 840px) {
//   .instruction-dialog {
//     padding: 24px 23px 24px 26px;
//     width: 100%;
//   }

//   // .img {
//   //   width: 100%;
//   // }
// }

// @media screen and (min-width: 699px) and (max-width: 799px) {
//   .img {
//     width: 90%;
//   }
// }
</style>
